import styled from "styled-components";

const Skills = styled.section`
`
export const S = {
    Skills
}